import BaseApi from "./baseApi";
import type { IdLike } from "../types";

class DeaneryApi extends BaseApi {
  async list(parishCategoryId?: IdLike): Promise<any> {
    const query = parishCategoryId
      ? `?parishCategoryId=${encodeURIComponent(String(parishCategoryId))}`
      : "";
    return await this.API({
      url: `/deaneries/list${query}`,
      method: "get",
    });
  }

  async addDeanery(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/deaneries/add",
      data,
      method: "post",
    });
  }

  async updateDeanery(
    data: Record<string, unknown> | object,
    id: IdLike,
  ): Promise<any> {
    return await this.API({
      url: `/deaneries/update/${id}`,
      data,
      method: "put",
    });
  }

  async deleteDeanery(id: IdLike): Promise<any> {
    return await this.API({
      url: `/deaneries/delete/${id}`,
      method: "delete",
    });
  }

  async searchDeanery(key: string): Promise<any> {
    return await this.API({
      url: `/deaneries/search/${key}`,
      method: "get",
    });
  }

  async parishesForCategory(parishCategoryId: IdLike): Promise<any> {
    return await this.API({
      url: `/deaneries/category/${parishCategoryId}/parishes`,
      method: "get",
    });
  }

  async assignParishes(id: IdLike, parishIds: number[]): Promise<any> {
    return await this.API({
      url: `/deaneries/assignments/${id}`,
      data: { parishIds },
      method: "put",
    });
  }
}

export default DeaneryApi;
